import React from 'react'
import PropTypes from 'prop-types'

/**
 * Component for adding a button with an icon
 */
function ButtonWithIcon ({ text, type, color, size, width, onClick, iconPosition, iconPath, disabled }) {
  const buttonClass = prop => prop ? 'btn-' + prop : null

  const classNames = [
    'btn',
    buttonClass(color),
    buttonClass(size),
    buttonClass(width)
  ]

  const right = (iconPosition === 'right') ? iconPath : null
  const left = !right ? iconPath : null

  return (
    <button type={type} onClick={onClick} className={classNames.join(' ')} disabled={disabled}>
      {left}
      {text}
      {right}
    </button>
  )
}

ButtonWithIcon.defaultProps = {
  color: 'primary',
  type: 'button',
  iconPosition: 'left'
}

ButtonWithIcon.propTypes = {
  /**
     * Button text
     */
  text: PropTypes.string.isRequired,
  /**
     * Button type attribute
     */
  type: PropTypes.string,
  /**
     * Color of the button<br>
     * Colors: 'primary', 'white', 'bordered'
     */
  color: PropTypes.string.isRequired,
  /**
     * Size of the button<br>
     * Sizes: 'default', 'small'
     */
  size: PropTypes.string,
  /**
     * Width of the button<br>
     * Sizes: 'default', 'wide', 'full'
     */
  width: PropTypes.string,
  /**
     * Icon SVG paths
     */
  iconPath: PropTypes.node.isRequired,
  /**
     * Icon position. Can be either 'left' or 'right'
     */
  iconPosition: PropTypes.string,
  /**
     * Disabled attribute
     */
  disabled: PropTypes.bool
}

export default ButtonWithIcon
